import Decimal from 'decimal.js';
import { getID } from './getID';

interface PlantingDataOut {
  readonly plantingId: string;
  readonly trays: number;
  readonly plantedAtTime?: number;
  readonly harvestTime: number;
}

interface PlantingDataIn {
  readonly id: string;
  readonly trays_rounded: string;
  readonly planted_at?: number | null;
  readonly planting_time: number;
}

export const groupPlantings = (plantings: readonly PlantingDataIn[]): readonly PlantingDataOut[] => {
  const groupedPlantings = plantings.reduce((acc, planting) => {
    // Group by planted at time and harvest time
    const key = `${planting.planted_at}-${planting.planting_time}`;
    const maybeExisting = acc.get(key);
    acc.set(key, {
      plantingId: getID(planting.id),
      trays: Decimal.add(planting.trays_rounded, maybeExisting?.trays ?? 0).toNumber(),
      plantedAtTime: planting.planted_at ?? undefined,
      harvestTime: planting.planting_time,
    });

    return acc;
  }, new Map<string, PlantingDataOut>());

  return [...groupedPlantings.values()];
};
